<template>
    <div class="page-container">
        <h3>{{ title }}</h3>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        title: String,
    },
};
</script>

<style scoped>
.page-container {
    padding: 20px 20px 50px;
}
h3 {
    text-transform: capitalize;
}
@media screen and (max-width: 600px) {
    .page-container {
        padding: 0;
        margin: 5px;
    }
}
</style>